<template>
  <div class="web-004-flooter">
    <div :class="['footer-container', isMobile && 'footer-container-mobile']">
      <div class="website-address">
        <div>联系地址：深圳市福田区车公庙天安数码城天经大厦AB座8楼</div>
        <div>联系电话：0755-83432800</div>
      </div>
      <div class="website-registration">
        <div>Copyright © 2025-2030 youxuezixishi.com All rights reserved</div>
        <div
          class="cr-no"
          @click="handleClickCRNo"
        >
          粤ICP备2025459542号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Flooter',
    props: {
        websiteMsg: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
    },
    methods: {
        handleClickCRNo () {
            window.open('https://beian.miit.gov.cn/', '_blank');
        },
    },
};
</script>

<style scoped lang="scss">
@import "../style.scss";
.web-004-flooter {
    width: 100%;
    height: 120px;
    background-color: #32343A;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    .footer-container {
        width: 1200px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 14px;
        line-height: 26px;
        &.footer-container-mobile {
            width: 100%;
            justify-content: center;
            flex-direction: column;
            font-size: 12px;
            line-height: 20px;
            .website-address {
                margin-bottom: 10px;
            }
        }
        .cr-no {
            cursor: pointer;
            user-select: none;
            &:hover {
                color: #2ED095;
                text-decoration: underline;
            }
        }
    }
}
</style>
